__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "hallosophia-integrations-calendly";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hallosophia/hallosophia-ui-components", "1.6.22", () => (Promise.all([__webpack_require__.e(834), __webpack_require__.e(676), __webpack_require__.e(613), __webpack_require__.e(416), __webpack_require__.e(51), __webpack_require__.e(418)]).then(() => (() => (__webpack_require__(13613))))));
			register("@sentry/integrations", "7.95.0", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(812)]).then(() => (() => (__webpack_require__(10812))))));
			register("@sentry/react", "7.95.0", () => (Promise.all([__webpack_require__.e(916), __webpack_require__.e(601), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(77601))))));
			register("antd", "5.2.1", () => (Promise.all([__webpack_require__.e(834), __webpack_require__.e(669), __webpack_require__.e(416), __webpack_require__.e(51)]).then(() => (() => (__webpack_require__(7669))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(164), __webpack_require__.e(416)]).then(() => (() => (__webpack_require__(54164))))));
			register("react", "18.2.0", () => (__webpack_require__.e(791).then(() => (() => (__webpack_require__(72791))))));
			register("universal-cookie", "7.0.1", () => (__webpack_require__.e(321).then(() => (() => (__webpack_require__(3321))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};